import React, { useContext, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';

import logo from '../../images/logo-hub-powered-by-insureon.svg';
import UserDispatch from '../../contexts/userDispatch';

import style from './PrivateHeader.module.css';

const PrivateHeader = React.memo(() => {
  const [loggedOut, setLoggedOut] = useState(false);

  const handleLogOut = event => {
    event.preventDefault();

    localStorage.removeItem('token');
    localStorage.removeItem('refresh');
    localStorage.removeItem('agencyId');

    setLoggedOut(true);
  };

  const user = useContext(UserDispatch);

  return !loggedOut ? (
    <header className={style.header}>
      <Link to="/" data-testid="global-hub-logo-link">
        <img src={logo} alt="logo" />
      </Link>
      <div className={style.agencyInfo}>
        <span className={style.agencyName}>{user.agencyName} |&nbsp;</span>
        <a href="/log-out" className={style.logOutBtn} onClick={handleLogOut}>
          Log out
        </a>
        <br />
        <span className={style.email}>{user.agencyUserEmail}</span>
      </div>
    </header>
  ) : (
    <Redirect to="/login" />
  );
});

export default PrivateHeader;
